import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddCon = (props) => {
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [time, setTime] = useState(
    (new Date().getHours() < 10
      ? "0" + new Date().getHours()
      : new Date().getHours()) +
      ":" +
      (new Date().getMinutes() < 10
        ? "0" + new Date().getMinutes()
        : new Date().getMinutes())
  );

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const validate = () => {
    if (!date || !time) {
      return false;
    } else {
      return true;
    }
  };

  const fetchCheckCon = async () => {
    var body = {
      con: props.con,
      id: props.lead.id,
      date: date,
      time: time,
    };

    await fetch("https://apisellcrm.ftpeople.pl/checkCon", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        props.close();
      })
      .catch((error) => {});
  };

  const checkCon = () => {
    if (validate()) {
      fetchCheckCon();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "2",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                DODAJ KONTAKT
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>

            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "99%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  data
                </p>
                <input
                  type="date"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div style={{ width: "99%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  czas
                </p>
                <input
                  type="time"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                gap: "20px",
              }}
            >
              <>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "green",
                    borderColor: "green",
                  }}
                  onClick={checkCon}
                >
                  DODAJ KONTAKT
                </button>
              </>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddCon;
